<template>
    <div class="fts-table-wrapper registration-requests">
        <h3 class="registration-requests-header">Overdue registration links</h3>
        <div class="filter-row">
            <div class="search-box">
                <input type="text" class="form-control" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
            </div>
            <div class="size-page-wrapper text-right">
                <label for="size-page">Display:</label>
                <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                    <option value="40">40</option>
                    <option value="60">60</option>
                    <option value="80">80</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
        <div class="fts-table table-responsive-sm table-requests-box">
            <table  v-if='requestsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment table-requests">
                <thead role="rowgroup">
                    <tr role="row">
                        <th @click="changeSort(1)" :aria-sort="setAreaSort(1)">Request created</th>
                        <th @click="changeSort(2)" :aria-sort="setAreaSort(2)">Company name</th>
                        <th @click="changeSort(3)" :aria-sort="setAreaSort(3)">User name</th>
                        <th>Phone number</th>
                        <th @click="changeSort(4)" :aria-sort="setAreaSort(4)">Country</th>
                        <th>Address</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="request in requestsList">
                        <td>{{request.createdAt}}</td>
                        <td>{{request.companyName}}</td>
                        <td>{{request.userName}}</td>
                        <td>{{request.phoneNumber}}</td>
                        <td>{{request.country}}</td>
                        <td>{{request.address}}</td>
                        <td class="actions-cell">
                            <button class="btn btn-confirm" @click="showConfirmModal(request.companyName, request.userName, request.activationKey)">Confirm Registration</button>
                            <i class="fa fa-times delete-request" @click="showDeleteModal(request.companyName, request.userName, request.activationKey)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="fts-bottom-table requests-pagination">
                <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                    <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                </nav>
            </div>

            <div class="no-requests" v-if="noRequests == true && loading == false">
                <h2 class="text">You have no Registration Requests</h2>
            </div>
        </div>

        <div class="loader-requests-list" v-if="loading == true && noRequests == false">
            <div class="sk-wave">
                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
            </div>
        </div>
        <b-modal id="confirmRegister" ref="confirmRegister" centered hide-header hide-footer size="md">
            <i class="fa fa-close" @click="hideConfirmModal"></i>
            <i class="fa fa-address-book-o"></i>
            <h3>Confirm Registration</h3>
            <p>You will be registering {{modalName}}, do You wish to continue?</p>
            <div class="buttons-row">
                <button class="btn btn-danger" @click="hideConfirmModal()">No</button>
                <button class="btn btn-success" @click="confirmRegister()">Yes</button>
            </div>
        </b-modal>
        <b-modal id="rejectRegister" ref="rejectRegister" centered hide-header hide-footer size="md">
            <i class="fa fa-close" @click="hideDeleteModal()"></i>
            <i class="fa fa-address-book-o"></i>
            <h3>Reject Registration</h3>
            <p>You will reject register of {{modalName}}, do You wish to continue?</p>
            <div class="buttons-row">
                <button class="btn btn-danger" @click="hideDeleteModal()">No</button>
                <button class="btn btn-success" @click="rejectRegister()">Yes</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import globalStore from "../../variables";
    import Axios from 'axios';
    export default {
        name: "RegistrationRequests",
        components: {
            Paginate: Paginate
        },
        data() {
            return {
                requestsList: [],
                loading: true,
                noRequests: false,
                sortSettings: {
                    size: 40,
                    desc: true,
                    sort: 1,
                    page: 1
                },
                filter: '',
                search: '',
                typingTimer: null,
                paginationCount: 1,
                modalName: null,
                key: null
            }
        },
        methods: {
            getRequests(resetPages) {
                this.loading = true;
                if (resetPages) {
                    this.sortSettings.page = 1
                    this.getPagination();
                }
                Axios.get( globalStore.data.restApiUrl + '/registration-enrollment/list?size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + '&page=' + this.sortSettings.page + this.search)
                    .then(response => {
                        this.requestsList = response.data
                        this.loading = false
                        this.noRequests = false
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            getPagination() {
                Axios.get(globalStore.data.restApiUrl + '/registration-enrollment/page-count?size=' + this.sortSettings.size + this.search)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getRequests(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                if (this.filter.length > 0) {
                    this.search = '&search=' + escape(this.filter);
                } else {
                    this.search = '';
                }
                this.getRequests(true);
            },
            sizePage() {
                this.getRequests(true);
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                this.getRequests(false);
            },
            showConfirmModal(companyName, userName, key) {
                if (companyName != "") {
                    this.modalName = companyName
                } else {
                    this.modalName = userName
                }
                this.key = key
                this.$refs['confirmRegister'].show();
            },
            hideConfirmModal() {
                this.modalName = null
                this.key = null
                this.$refs['confirmRegister'].hide();
            },
            showDeleteModal(companyName, userName, key) {
                if (companyName != "") {
                    this.modalName = companyName
                } else {
                    this.modalName = userName
                }
                this.key = key
                this.$refs['rejectRegister'].show();
            },
            hideDeleteModal() {
                this.modalName = null
                this.key = null
                this.$refs['rejectRegister'].hide();
            },
            confirmRegister() {
                Axios.post(globalStore.data.restApiUrl + '/registration-enrollment/' + this.key)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Register requested confirmed',
                            text: 'You confirmed register of ' + this.modalName + '.',
                            duration: 3000,
                        });
                        this.getRequests(true)
                        this.hideConfirmModal()
                    })
                    .catch(error =>{
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Register requested not confirmed',
                            text: 'An error has occured during confirming register of ' + this.modalName + '. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            rejectRegister() {
                Axios.patch(globalStore.data.restApiUrl + '/registration-enrollment/' + this.key)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Register requested deleted',
                            text: 'You rejected register of ' + this.modalName + '.',
                            duration: 3000,
                        });
                        this.getRequests(true)
                        this.hideDeleteModal()
                    })
                    .catch(error =>{
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Register requested not deleted',
                            text: 'An error has occured during rejecting register of ' + this.modalName + '. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
        },
        mounted() {
            this.getRequests(true);
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    .registration-requests {
        padding-bottom: 75px;
        background-color: #fff;
        border: 1px solid #C9CFD4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        .registration-requests-header {
            padding: 20px;
            margin: 0;
            border-bottom: 1px solid #C9CFD4;
            color: #2F353A;
            font-size: 15px;
            font-weight: 700;
        }

        .filter-row {
            display: flex;
            justify-content: space-between;
            padding: 12px 20px;
            border-bottom: 1px solid #C9CFD4;
            .size-page-wrapper {
                display: flex;
                align-items: center;
                label {
                    margin: 0 12px 0 0;
                }
            }
        }

        .table-requests-box {
            position: relative;
            min-height: 600px;
            .table-requests {
                thead {
                    th {
                        border-bottom: 1px;
                    }
                }
                .actions-cell {
                    .btn-confirm {
                        margin: 0 20px 0 0;
                        background-color: #00C4B0;
                        color: #ffffff;
                    }
                    .delete-request {
                        position: relative;
                        color: #FC4D4D;
                        &:hover {
                            &:after {
                                position: absolute;
                                right: 110%;
                                bottom: 110%;
                                content: 'Delete request';
                                padding: 8px 16px;
                                background-color: #241717;
                                color: #ffffff;
                                font-family: sans-serif;
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
            .requests-pagination {
                display: flex;
                justify-content: center;
                bottom: initial;
            }
        }

        .loader-requests-list,
        .no-requests {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
        }


    }

    #confirmRegister___BV_modal_body_,
    #rejectRegister___BV_modal_body_{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        .fa-close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
        .fa-address-book-o {
            margin: 0 0 12px;
            font-size: 22px;
            color: #0088FF;
        }
        h3 {
            margin: 0 0 20px;
            font-size: 15px;
            font-weight: 700;
        }
        p {
            width: 460px;
            margin: 0 0 16px;
            text-align: center;
            font-size: 14px;
            line-height: 24px;
            color: #515B65;
        }
        .buttons-row {
            .btn {
                width: 70px;
                &:first-child {
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    .dark-theme {
        .registration-requests {
            background-color: #3a4149;
            color: #fff;
            border-color: #1a1c1d;
            .registration-requests-header {
                color: #fff;
                border-color: #1a1c1d;
            }
            .filter-row {
                .search-box {
                    input {
                        background-color: #515b65;
                        color: #fff;
                        border-color: #1a1c1d;
                        &::placeholder {
                            color: #fff;
                        }
                    }
                }
                .size-page-wrapper {
                    .custom-select {
                        background-color: #515b65;
                        color: #fff;
                        border-color: #1a1c1d;
                    }
                }
            }


            .loader-requests-list,
            .no-requests {
                background-color: rgba(0, 0, 0, 0.4);
            }

        }

        #confirmRegister___BV_modal_body_,
        #rejectRegister___BV_modal_body_{
            p {
                color: #fff;
            }
        }
    }
</style>
